import React from "react"
import ReactLoading from "react-loading"

const Loading: React.FC = () => (
  <div className="container my-4">
    <div className="row justify-content-center align-items-center">
      <div className="col flex-grow-0">
        <ReactLoading
          type="spin"
          color="#152a49"
        />
      </div>
    </div>
  </div>
)

export default Loading
